
import request from '../request'

//删除
export function deleteFence(id) {
    return request({
        url: '/dzwl/deleteDzwl?id='+id,
        method: 'get',
        data: {}
    })
}

export function createFence(data){
    return request({
        url: '/dzwl/createDzwl',
        method: 'post',
        data: data
    })
}